module.exports = __webpack_public_path__ + "img/kiko.f37df540.png";